import React, {ReactElement} from 'react'
import {SessionStorageHelper} from '../SessionStorageHelper'

interface Props {
    permittedAuthorities: string[]
    children?: React.ReactNode
}

export default class PartialAuthorityChecker extends React.Component<Props> {
    render(): ReactElement {
        const authorities: string[] = JSON.parse(SessionStorageHelper.getStringItemWithDefault('AUTHORITIES', '[]'))
        // @ts-ignore
        return this.props.permittedAuthorities.some(
            (permittedAuthority: string) => authorities.includes(permittedAuthority)
        ) ? this.props.children : null
    }
}
